'use client';

import { Duration } from '@/lib/duration';
import { PropsWithChildren, useRef } from 'react';
import { addBase, createSuperContext } from 'superctx';
export const STABLE_TIMESTAMP_REFRESH_RATE = Duration.from({
  minutes: 60
}).toMillis();
type StableTimestampContextValue = {
  getTimestamp: () => Date;
};
export const StableTimestamp = addBase(createSuperContext<StableTimestampContextValue>({
  notProvidedMessage: 'StableTimestamp must be used within a StableTimestampProvider'
}), Provider => function StableTimestampProvider({
  children
}: PropsWithChildren) {
  const stableNowMsRef = useRef(Date.now());
  const getTimestamp = (): Date => {
    const nowMs = Date.now();
    const ageMs = nowMs - stableNowMsRef.current;
    if (ageMs < STABLE_TIMESTAMP_REFRESH_RATE) {
      return new Date(stableNowMsRef.current);
    }
    stableNowMsRef.current = nowMs;
    return new Date(nowMs);
  };
  return <Provider value={{
    getTimestamp
  }}>{children}</Provider>;
});